<template lang="pug">
  #footer
    .footer-inner
      .contact(v-if="isMethodology")
        p.m-0 Para preguntas, sugerencias o aportes de información contactar a:
          a(href="mailto:comunicacion@article19.org" target="_blank") comunicacion@article19.org
      .support(v-if="isHome")
        .support-logos
          img.img-fluid(alt="hrdag" src="@/assets/logos/hrdag_logo.png")
          img.img-fluid(alt="fondo-canada" src="@/assets/logos/Fondo-Canada-Blanco-SF.png")
        p.thanks.bold-font Agradecemos la colaboración del Fondo Canadá y del Human Rights Data Analysis Group para el impulso de esta plataforma (2020-2021)
      //- .credits(v-if="isHome")
      //-   .credits-block
      //-     p.section-title.bold-font Artículo 19
      //-     p.mb-1 Coordinadora de prevención • Jessica Alcázar
      //-     p.mb-1 Periodista y consultora • Wendy Selene Pérez
      //-   .credits-block
      //-     p.section-title.bold-font Programa de Derechos Humanos de la IBERO
      //-     p.mb-1 Coordinadora del PDH • Andrea Horcasitas
      //-     p.mb-1 Procesamiento de datos • Fernanda Lobo
      //-   .credits-block
      //-     p.section-title.bold-font Data Cívica
      //-     p.mb-1 Coordinación general de esta actualización y del procesamiento de datos • Pamela Benítez
      //-   p.mb-1 Corrección de estilo y revisión editorial • Nora Hinojo
      //-   p.mb-1 Diseño editorial e ilustraciones de acompañamiento • Diana Cruz R.
      //-   p.mb-0 Desarrollo • Basem Hamza y Jorge Andrade

</template>
<script>
export default {
  name: "Footer",
  computed: {
    isHome() {
      return this.$route.name === "Home";
    },
    isMethodology() {
      return this.$route.name === "Methodology";
    },
  },
};
</script>
<style lang="scss">
@import "@/global.scss";
#footer {
  padding: 28px 16px 36px;
  .footer-inner {
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
    text-align: center;
  }
  .contact {
    font-size: 13px;
  }
  .support {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    .support-logos {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 20px;
      img {
        max-height: 56px;
        width: auto;
      }
    }
    .thanks {
      max-width: 820px;
    }
  }
  .credits {
    max-width: 900px;
    margin: 0 auto;
    text-align: left;
    font-size: 13px;
    line-height: 1.5;
    .section-title {
      margin-bottom: 4px;
    }
    p {
      margin-bottom: 6px;
    }
    .credits-block {
      margin-bottom: 10px;
    }
  }
  a {
    color: white !important;
  }
}
</style>
